import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { Icon } from '@inter-ikea-kompis/component-icon';
import { Text } from '@inter-ikea-kompis/component-text';

import DividerTypeEnum from '../../enums/DividerTypeEnum.js';
import DividerStyle from './DividerStyle.js';

/**
 * Divider class.
 */

export default class Divider extends KompisElement {
	// Type of divider.
	@property({ type: String })
	public type: DividerTypeEnum = DividerTypeEnum.thin;

	// Theme
	@property({ type: Object, required: true })
	public theme!: ITheme;
	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		return html`
			<style>
				${DividerStyle.getStyle({
					type: this.type,
					theme: this.theme
				})}
			</style>
		`;
	}

	public override connectedCallback(): void {
		this.customElements.define('kompis-text', Text);
		this.customElements.define('kompis-icon', Icon);

		super.connectedCallback();
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-divider': Divider;
	}
}
